import React, { useState } from 'react';
import { EmailVariablesFormVM } from './email-variables-form.viewmodel';
import { CommonPopupBodyFooterLayout } from '../../common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../sub-window/common/common-close-sub-window-buttons';
import { cancelText } from '../../../../constants/common-labels.constants';
import { SearchInput } from '../../search-input/search-input';
import { CopyButton } from '../../copy-button/copy-button';
import { IEmailVariable } from '../../../../api/email-templates.dao';
import { useIntl } from 'react-intl';
import { EMAIL_VARIABLES_LOADING_TEXT } from '../email-variables.texts';

interface IProps {
    vm: EmailVariablesFormVM;
};

export const EmailVariablesFormPresentation = ({ vm }: IProps): JSX.Element => {
    const [search, setSearch] = useState<string>('');
    const intl = useIntl();

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>, v: string) => {
        e.preventDefault();
        setSearch(v);
    };

    const getFilteredVariables = (): IEmailVariable[] => {
        if (!search) return vm.variables;
        const trimedSearch = search.trim().toLowerCase();

        return vm.variables.filter(x => {
            return x.value.toLowerCase().includes(trimedSearch)
                || x.description.toLowerCase().includes(trimedSearch);
        });
    };

    if (vm.loading) {
        return (
            <CommonPopupBodyFooterLayout
                body={
                    <div className='oe-form'>
                        {intl.formatMessage(EMAIL_VARIABLES_LOADING_TEXT)}
                    </div>
                }
            />
        );
    }

    return (
        <CommonPopupBodyFooterLayout
            body={
                <>
                    <div className='email-variables__search-input-wrapper'>
                        <SearchInput value={search} onChange={handleSearch} />
                    </div>
                    <div className='email-variables-fields-wrapper'>
                        {getFilteredVariables().map((x: IEmailVariable) => {
                            return (
                                <div className='email-variables-field' key={x.value}>
                                    <div>
                                        <b className='email-variables-field__value'>{x.value}</b>
                                        <CopyButton className='text-with-copy__button' copyValue={x.value} withoutIcon />
                                    </div>
                                    <span className='email-variables-field__description'>{x.description}</span>
                                </div>
                            );
                        })}
                    </div>
                </>
            }

            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton text={cancelText()} />
                </div>
            }
        />

    );
};

